var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"quotes",attrs:{"row":"","wrap":""}},[_c('documents-display',{attrs:{"type":"Quotes","display-qty":_vm.displayQty,"grid":true,"title":"QUOTES | In Progress"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }